import "./ChangePassword.scss";
import "./ChangePasswordMobile.scss";
import { FaKey, FaLock, FaRegEnvelope } from "react-icons/fa";
import "./ForgotPass.scss";
import { useState } from "react";
import ItachiEyePassword from "../../ItachiEyePassword/itachiEyePassword";
import PasswordRequirements from "../../../PageSignup/PasswordInput/PasswordRequirements";
import SignupPasswordValidator from "../../../PageSignup/SignupPasswordValidator";
import PasswordStrength from "../../../PageSignup/PasswordInput/PasswordStrength";
export default function ChangePassword({
  setModalOpen,
  setEmailForForgot,
  emailForForgot,
}) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");

  const validation = SignupPasswordValidator(newPassword);
  const allValid = Object.values(validation).every(Boolean);
  const passwordsMatch =
    newPassword && newPasswordConfirm && newPassword === newPasswordConfirm;
  const handleSharinganClick = () => {
    setShowPassword((prev) => !prev);
  };
  const handleSharinganConfirmClick = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const handleChangePass = async () => {
    const email = emailForForgot;
    if (!passwordsMatch) {
      alert("Passwords not matched.");
      return;
    }
    if (!email.trim()) {
      alert("Email is required.");
      return;
    } else if (!validateEmail(emailForForgot)) {
      alert("Please enter a valid email address.");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/auth/change-password`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ email, newPassword }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        alert(data.error || "Login failed. Please try again.");
      } else {
        alert(
          "Password changed successfully, You may now login using your new password."
        );
        setEmailForForgot("");
        setModalOpen(""); // open modal
      }
    } catch (error) {
      console.error(error);
      alert("Network error. Please try again later.");
    }
  };
  return (
    <>
      {" "}
      <div className="changePass-container">
        <div className="icon-wrapper">
          <FaKey />
        </div>
        <h2>CHANGE PASSWORD</h2>

        <div className="enter-password-wrapper">
          <span>Enter new password:</span>
          <div className="input-container">
            <div className="input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
              <ItachiEyePassword
                className="sharingan"
                onLoginClick={handleSharinganClick}
              />
            </div>

            <PasswordStrength allValid={allValid} />
          </div>
        </div>

        <PasswordRequirements validation={validation} />
        <div className="enter-password-wrapper">
          <span>Confirm new password:</span>
          <div className="input-container">
            <div className="input-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={newPasswordConfirm}
                onChange={(e) => setNewPasswordConfirm(e.target.value)}
              />

              <ItachiEyePassword
                className="sharingan"
                onLoginClick={handleSharinganConfirmClick}
              />
            </div>{" "}
            <div className="sp-form-password-strength">
              {newPasswordConfirm && (
                <p className={passwordsMatch ? "valid" : "invalid"}>
                  {passwordsMatch ? "MATCHED" : "NOT MATCHED"}
                </p>
              )}
            </div>
          </div>
        </div>

        <button className="otp-button" onClick={handleChangePass}>
          CHANGE PASSWORD
        </button>
      </div>
    </>
  );
}
